import { jsx as l } from "react/jsx-runtime";
import { Button as r } from "../Button/index.js";
const g = ({
  active: n,
  size: i,
  onClick: e,
  disabled: o,
  ...t
}) => /* @__PURE__ */ l(
  r,
  {
    ...t,
    ...(() => {
      const a = "icon" in t && "label" in t, c = "text" in t && "icon" in t;
      return a ? {
        icon: t.icon,
        label: t.label,
        withTooltip: !1
      } : c ? { text: t.text, icon: t.icon } : { text: t.text };
    })(),
    size: i,
    onClick: e,
    disabled: o,
    type: "button",
    variant: n ? "primary" : "ghost",
    full: !1
  }
);
export {
  g as ToggleButton
};
//# sourceMappingURL=index.js.map
